<template>
  <v-container class="pa-4 pa-sm-8" fluid>
    <v-layout wrap class="mt-3 mt-sm-0 mb-2">
      <v-flex>
        <h2 class="dark--text font-weight-bold">Home Page Package Settings</h2>
      </v-flex>
      <v-spacer></v-spacer>

      <AddHomePagePackage />

      <!-- <app-faq-form v-if="hasRole(AdminUserPermissions.FAQ_ADD)"></app-faq-form> -->
    </v-layout>
    <v-data-table :mobile-breakpoint="0" :headers="headers" :items="itemsWithSno" class="elevation-1" :loading="loading" :footer-props="{ 'items-per-page-options': [25, 50, 100, 500] }">
      <template v-slot:item.packageImage="{ item }">
        <v-avatar :width="40" :height="40">
          <v-img v-if="item.packageImage.length != 0" :src="`${imageUrl}${item.packageImage}`" />
        </v-avatar>
      </template>
      <template v-slot:item.packageImageMob="{ item }">
        <v-avatar :width="40" :height="40">
          <v-img v-if="item.packageImageMob.length != 0" :src="`${imageUrl}${item.packageImageMob}`" />
        </v-avatar>
      </template>
      <template v-slot:item.actions="{ item }">
        <v-row>
          <UpdateHomePagePackage :data="item" />
          <DeleteHomePagePackage :data="item" />
        </v-row>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import UpdateHomePagePackage from "../components/UpdateHomePagePackage.vue";
import AddHomePagePackage from "../components/AddHomePagePackage.vue";
import DeleteHomePagePackage from "../components/DeleteHomePagePackage.vue";
export default {
  components: {
    UpdateHomePagePackage,
    AddHomePagePackage,
    DeleteHomePagePackage,
  },
  methods: {},
  data: () => ({
    imageUrl: process.env.VUE_APP_BASE_URL,
    loading: true,
    packageDetails: [],
    headers: [
      {
        text: "#",
        value: "slNo",
        sortable: false,
        width: 90,
      },

      {
        text: "Plan Show Type",
        value: "planShowType",
        width: 150,
        sortable: false,
      },
      {
        text: "Price",
        value: "price",
        width: 150,
        sortable: false,
      },

      {
        text: "Package",
        value: "package.titleEn",
        sortable: false,
        width: 120,
      },
      {
        text: "Image",
        value: "packageImage",
        sortable: false,
        width: 120,
      },
      {
        text: "Image Mob",
        value: "packageImageMob",
        sortable: false,
        width: 120,
      },
      { text: "Action", value: "actions", sortable: false, width: 90 },
    ],
  }),
  apollo: {
    getWebHomePackage() {
      // console.log("djfd");
      return {
        query: require("../api/getWebHomePackage.graphql"),
        result({ data, loading }) {
          this.loading = loading;
          this.packageDetails = data.getWebHomePackage.WebHomePackage;
        },
      };
    },
  },
  computed: {
    itemsWithSno() {
      if (this.packageDetails == null) return [];
      return this.packageDetails.map((d, index) => ({ ...d, slNo: index + 1 }));
    },
  },
  mounted() {
    this.$root.$on("updateHomePackage", () => {
      this.$apollo.queries.getWebHomePackage.refetch();
    });
  },
  created() {
    // if (!this.hasRole(this.AdminUserPermissions.FAQ_VIEW)) {
    //   this.$router.push({
    //     name: "Error404",
    //   });
    // }
  },
};
</script>
